let locked = false;
let lockedScrollY = 0;

// Inline styles (not a CSS class) so the lock works in every layout chunk,
// and body top compensation preserves the scroll position while locked.
export const useScrollLock = () => {
    const lockScroll = () => {
        if (!import.meta.client || locked) return;
        locked = true;
        lockedScrollY = window.scrollY;

        const { body, documentElement } = document;
        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = `-${lockedScrollY}px`;
        body.style.width = '100vw';
        body.style.overscrollBehavior = 'none';
        documentElement.style.overflow = 'hidden';
        documentElement.style.overscrollBehavior = 'none';
    };

    const unlockScroll = () => {
        if (!import.meta.client || !locked) return;
        locked = false;

        const { body, documentElement } = document;
        body.style.removeProperty('overflow');
        body.style.removeProperty('position');
        body.style.removeProperty('top');
        body.style.removeProperty('width');
        body.style.removeProperty('overscroll-behavior');
        documentElement.style.removeProperty('overflow');
        documentElement.style.removeProperty('overscroll-behavior');
        window.scrollTo(0, lockedScrollY);
    };

    return { lockScroll, unlockScroll };
};
